export default "__VITE_ASSET__B2mvO6Yr__"